module.exports = __webpack_public_path__ + "img/machineing_card.dbe797a5.jpg";